import script from "./lyWidgetPannel.vue?vue&type=script&setup=true&lang=js"
export * from "./lyWidgetPannel.vue?vue&type=script&setup=true&lang=js"

import "./lyWidgetPannel.vue?vue&type=style&index=0&id=42e1d86a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e1d86a"]])

export default __exports__